import { USER_ROLES } from './constants.js';

/**
 * Fetch questions via AJAX
 * @returns {Promise<Object>} Data object with questions and user_role
 */
export async function fetchQuestions() {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_questions');
	formData.append('nonce', wpcore.nonce);

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
			credentials: 'include',
		});
		const data = await response.json();

		if (data.success) {
			return data.data;
		}
		return { questions: [], user_role: USER_ROLES.STUDENT };
	} catch (error) {
		console.error('Error fetching questions:', error);
		return { questions: [], user_role: USER_ROLES.STUDENT };
	}
}

/**
 * Save a new question via AJAX
 * @param {Object} data { content: string, files: File[] }
 * @returns {Promise<Object>} Response from server
 */
export async function saveQuestion(data) {
	const formData = new FormData();
	formData.append('action', 'wpcore_create_question');
	formData.append('nonce', wpcore.nonce);
	formData.append('content', data.content);

	if (data.files && data.files.length > 0) {
		data.files.forEach((file) => {
			formData.append('attachments[]', file);
		});
	}

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
			credentials: 'include',
		});
		const result = await response.json();
		return result;
	} catch (error) {
		console.error('Error saving question:', error);
		return { success: false, message: wpcore.direct_t({ en: 'An error occurred while saving the question.', fr: 'Une erreur est survenue lors de l\'enregistrement de la question.' }) };
	}
}

/**
 * Coach answers a question via AJAX
 * @param {Object} data { id: number, content: string, files: File[] }
 * @returns {Promise<Object>} Response from server
 */
export async function answerQuestion(data) {
	const formData = new FormData();
	formData.append('action', 'wpcore_answer_question');
	formData.append('nonce', wpcore.nonce);
	formData.append('id', data.id);
	formData.append('content', data.content);

	if (data.files && data.files.length > 0) {
		data.files.forEach((file) => {
			formData.append('attachments[]', file);
		});
	}

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
			credentials: 'include',
		});
		const result = await response.json();
		return result;
	} catch (error) {
		console.error('Error answering question:', error);
		return { success: false, message: wpcore.direct_t({ en: 'An error occurred while sending the response.', fr: 'Une erreur est survenue lors de l\'envoi de la réponse.' }) };
	}
}
